import { render, staticRenderFns } from "./trainers-list.vue?vue&type=template&id=31a54e24&"
import script from "./trainers-list.vue?vue&type=script&lang=js&"
export * from "./trainers-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports